import { useMemo } from 'react';
import { Typography, CustomModal, DeclarativeModal, makeStyles } from 'seagull';
import { RichTextViewer } from "../RichTextViewer";
import { jsx as _jsx } from "react/jsx-runtime";
const useStyles = makeStyles({
  content: {
    width: 720,
    margin: '24px 40px 32px 40px'
  }
});
function getDefaultText(text) {
  if (!text) {
    return [];
  }
  return typeof text === 'string' ? [{
    typ: 'p',
    children: [{
      text
    }]
  }] : text;
}
export default function RichTextViewerModal(_ref) {
  let {
    show,
    title,
    text,
    onCancel
  } = _ref;
  const styles = useStyles();
  const richText = useMemo(() => getDefaultText(text), [text]);
  return /*#__PURE__*/_jsx(DeclarativeModal, {
    isOpen: show,
    onClose: onCancel,
    content: () => /*#__PURE__*/_jsx(CustomModal, {
      maxWidth: 800,
      header: /*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        "data-testid": "rich-text-viewer-modal-title",
        children: title
      }),
      children: /*#__PURE__*/_jsx("div", {
        className: styles.content,
        "data-testid": "rich-text-viewer-modal-content",
        children: /*#__PURE__*/_jsx(RichTextViewer, {
          value: richText
        })
      })
    })
  });
}